<section id="enfoque" class="modern-features modern-section dingo-section dingo-bg-accent approach-section">
  <div class="container">
    <div class="approach-section-head home-section-head section-head reveal-on-scroll" data-reveal="section-head">
      <div>
        <p class="home-section-kicker">Metodología DINGO</p>
        <h2 class="home-section-title">
          Growth con método, no con <span class="highlight-green">suposiciones</span>
        </h2>
      </div>
      <div class="approach-section-copy">
        <p class="home-section-desc">
          Un sistema claro, medible y ejecutable para convertir estrategia en crecimiento sostenido.
        </p>
      </div>
    </div>

    <div class="approach-timeline" #approachTimeline>
      <div class="approach-timeline-line">
        <span class="approach-timeline-progress"></span>
      </div>

      <div class="approach-step-list">
      @for (step of approachSteps; track step.id; let i = $index) {
      <article class="approach-timeline-item" [attr.data-step-index]="i + 1">
        <div class="approach-timeline-card">
          <div class="approach-timeline-dot">
            <i class="bi {{ step.icon }} approach-timeline-icon"></i>
          </div>
          <div class="approach-card-content">
            <span class="approach-timeline-step">Paso {{ i + 1 }}</span>
            <h3>{{ step.title }}</h3>
            <p>{{ step.description }}</p>
            @if (step.outcome) {
            <p class="approach-timeline-outcome">{{ step.outcome }}</p>
            }
          </div>
          <span class="approach-step-number">0{{ i + 1 }}</span>
        </div>
      </article>
      }
      </div>
    </div>
  </div>
</section>
